import {
    createRegisterableComposition,
    isArticleLikeType,
} from '@news-mono/web-common'
import { AccessLevels } from '@west-australian-newspapers/message-types'
import React from 'react'
import { getPublicationInfoFromRouteResolution } from '../../templates'
import { ContainerWidth, ThemeMargins } from '../../__styling/settings/metrics'
import { ContentWrapper } from '../ContentWrapper/ContentWrapper'
import { BaseCompositionProps } from '../types'
import { Athena, SidebarOptions } from './Athena'

export interface AthenaRouteProps extends BaseCompositionProps {
    verticalSpacing?: keyof ThemeMargins
    containerWidth?: ContainerWidth
    stackSidebarContent?: boolean
    sidebarOptions: SidebarOptions
    elementType: 'div' | 'article'
    hasHorizontalGutters?: boolean
    hasVerticalPadding?: boolean
    hasHorizontalPadding?: boolean
    sidebarSide?: 'right' | 'left'
}

export const AthenaRegistration = createRegisterableComposition<
    'main' | 'sidebar'
>()('athena', (contentAreas, props: AthenaRouteProps, services) => {
    const publicationInfo = getPublicationInfoFromRouteResolution(services)
    let requiredAccessLevel: AccessLevels = 'anonymous'

    if (isArticleLikeType(publicationInfo.publication)) {
        requiredAccessLevel = publicationInfo.publication.requiredAccess.level
    }

    return (
        <ContentWrapper
            stretchColumns={props.stretchColumns}
            stretchSelf={props.stretchSelf}
        >
            <Athena
                {...props}
                mainContent={contentAreas.main}
                sidebarContent={contentAreas.sidebar}
                isPremiumArticle={requiredAccessLevel === 'subscriber'}
            />
        </ContentWrapper>
    )
})
